import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static targets = ["display", "form", "input"];

  async regenerate(event) {
    try {
      await post(event.currentTarget.dataset.url, { responseKind: "turbo-stream" });
    } catch (error) {
      console.error("Massimo chat name regeneration failed:", error);
    }
  }

  startEdit() {
    this.showForm();
    this.inputTarget.focus();
    this.inputTarget.select();
  }

  cancelEdit() {
    this.inputTarget.value = this.inputTarget.defaultValue;
    this.showDisplay();
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.submit();
    } else if (event.key === "Escape") {
      event.preventDefault();
      this.cancelEdit();
    }
  }

  onBlur() {
    if (this.formTarget.classList.contains("hidden")) return;
    this.submit();
  }

  submit() {
    // guards a double submit when a blur follows Enter
    if (this.submitting) return;
    if (this.inputTarget.value === this.inputTarget.defaultValue) {
      this.cancelEdit();
      return;
    }
    this.submitting = true;
    this.formTarget.requestSubmit();
  }

  submitEnded(event) {
    this.submitting = false;
    if (!event.detail.success) {
      this.showForm();
      this.inputTarget.focus();
    }
  }

  showForm() {
    this.displayTarget.classList.add("hidden");
    this.formTarget.classList.remove("hidden");
  }

  showDisplay() {
    this.formTarget.classList.add("hidden");
    this.displayTarget.classList.remove("hidden");
  }
}
